export enum TextItemMediaClickActionType {
    EnlargedView = 0,
    DownloadFile = 1,
}
